module.exports = __webpack_public_path__ + "static/looper_mobile-d577bd2bf7efe947373bd993fdd9498f.mp4";